import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2839">
      <Navbar data-id="element-2840" />
      <main data-id="element-2841">
        <ConsularAffairs data-id="element-2842" />
      </main>
      <Footer data-id="element-2843" />
      <FeedbackPopup data-id="element-2844" />
    </div>;
}